import { useRef, useState } from 'react';

export function useWizardStepData(initialData, onDataChange) {
  const [data, setDataState] = useState(initialData);
  const dataRef = useRef(initialData);

  const setData = (d: ((s: any) => any) | any) => {
    const newData = typeof d === 'function' ? d(dataRef.current) : d;
    dataRef.current = newData;
    onDataChange(newData);
    setDataState(newData);
  };

  return [data, setData];
}
